import { marketConstants } from '../_constants';

export function markets(state = {}, action) {
    switch (action.type) {
        case marketConstants.GETALL_REQUEST:
            return { loading: true }
        case marketConstants.GETALL_SUCCESS:
            return action.markets
        case marketConstants.GETALL_FAILURE:
            return { error: action.error }
        default:
            return state
    }
}
